import apiConfig from './api'

export default {
  getNewsList: () => `${apiConfig.apiEndpoint}/api/${apiConfig.space}/database/news/row`,
  getNewDetail: () => `${apiConfig.apiEndpoint}/api/${apiConfig.space}/database/news/row`
}
